<template>
  <BContainer fluid class="app_players_footer">
  <BContainer>
    <BRow class="justify-content-center pt-5 pb-5">
      <BCol cols="12" md="3" >
        <div class="text-dark">
          <h5>Reporters:</h5>
          <h4>Marcos Garcia Rey, Jesús Escudero, Denise Ajiri, Agustin Armendariz, Tom Rowley, Matei Rosca, Mikhail Rubin, Hannes Munzinger, Carina Huppertz, Karlijn Kuijpers, Sylvain Besson, Will Dahlgreen</h4>
        </div>
      </BCol>
      <BCol cols="12" md="3" >
        <div class="text-dark">
          <h5>Editors:</h5>
          <h4>Joanna Robin</h4>
          
          <h5>Data and research editor:</h5>
          <h4>Delphine Reuter</h4>
          
        </div>
      </BCol>
      <BCol cols="12" md="3" >
        <div class="text-dark">
          <h5>Fact-checker:</h5>
          <h4>Richard H.P. Sia</h4>
          <h5>Data visualization:</h5>
          <h4>Antonio Cucho Gamboa</h4>
        </div>
      </BCol>
    </BRow>
  </BContainer>
  <generic-footer class="generic-footer">
    <template slot="address">
      <div>
        1730 Rhode Island Ave NW, Suite 317
      </div>
      <div>
        Washington, D.C. 20036 USA
      </div>
    </template>
    <template slot="investigations">
      <div>
        <ul class="list-unstyled">
          <li class="list-unstyled-item">
            <a target="_parent" data-ga="Footer|click|Deforestation Inc.|1" href="https://www.icij.org/investigations/swazi-secrets/">
            Swazi Secrets
            </a>
            </li>
          <li class="list-unstyled-item">
            <a target="_parent" data-ga="Footer|click|Deforestation Inc.|1" href="https://www.icij.org/investigations/cyprus-confidential/">
            Cyprus Confidential
            </a>
            </li>
          <li class="list-unstyled-item">
            <a target="_parent" data-ga="Footer|click|Deforestation Inc.|1" href="https://www.icij.org/investigations/deforestation-inc/">
            Deforestation Inc.
            </a>
            </li>
                      <li class="list-unstyled-item">
            <a target="_parent" data-ga="Footer|click|Shadow Diplomats|1" href="https://www.icij.org/investigations/shadow-diplomats/">
            Shadow Diplomats
            </a>
            </li>
                      <li class="list-unstyled-item">
            <a target="_parent" data-ga="Footer|click|Trafficking Inc.|1" href="https://www.icij.org/investigations/trafficking-inc/">
            Trafficking Inc.
            </a>
            </li>
                    <li class="list-unstyled-item">
            <a target="_parent" data-ga="Footer|click|All investigations|1" href="https://www.icij.org/investigations/investigations/">
            More investigations
            </a>
          </li>
        </ul>
      </div>
    </template>
    
  </generic-footer>
  </BContainer>
</template>

<style lang="scss">
  .logo-icij {
    width: 100%;
    max-width: 260px;
    margin: 25px 0;
  }

  .app_players_footer {
    position: relative;
    padding: 0 0;
    background: #d3e7c5eb;

    svg {
      width: 100%;
      max-width: 280px;
    }

    h4 {
      font-size: 16px;
      font-weight:400;
      line-height: 1.5em;
    }

    h5 {
      font-size: 13px;
      font-weight: 600;
      color: var(--app-color-black);
    }
  }

  .menu-title {
    color: #e3e3e3;
    font-size: 13px;
    margin-top: 25px;
  }

  .list-unstyled-item {
    a {
      display: block;
      color: #fff;
      margin-bottom: 15px;
      font-weight: 600;
    }
  }
</style>

<script>
  export default {
    name: "AppFooter"
  }
</script>